<div class="intralinks-groups">
    <div class="filter-container">
        <span class="filter-left">Last
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="timeValueOptions"
                [(ngModel)]="timeValue" [textField]="'text'" [valueField]="'data'"
                (selectionChange)="onFilterChange('value',$event)">
            </kendo-dropdownlist>
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="timeUnitOptions"
                [(ngModel)]="timeUnit" [textField]="'text'" [valueField]="'data'"
                (valueChange)="onFilterChange('unit',$event)" [style.width.px]="90">
            </kendo-dropdownlist>
        </span>
    </div>
    <div class="group-container" *ngFor="let groupConfig of groupConfigs">
        <tam-intralinks-group [config]="groupConfig"></tam-intralinks-group>
    </div>
    <div class='spinner' loading-spin [isLoading]="loadCountdown>0" [loadingSize]="'big'"></div>
    <div class="no-data" *ngIf="noData">No Data Found</div>
</div>